import queryString from 'query-string';

export default (location, paramName) =>
  queryString.parse(location.search)[paramName];
